import { render } from "./DriveView.vue?vue&type=template&id=87d9bd7a"
import script from "./DriveView.vue?vue&type=script&lang=js"
export * from "./DriveView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__